module.exports = __webpack_public_path__ + "static/img/11.d6c2b83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour5/11.jpg
// module id = kjsH
// module chunks = 0